const modalSelector = '#income-action-modal';
const deleteModalSelector = '#income-delete-modal';

const parseJsonErrors = (errors = {}) => Object.entries(errors).flatMap(([field, messages]) => {
    if (!Array.isArray(messages)) {
        return [];
    }

    return messages.map(message => ({ field, message }));
});

const escapeHtml = value => $('<div/>').text(value || '').html();

const displayDateFormat = 'dd.mm.yyyy';
const isoDatePattern = /^(\d{4})-(\d{2})-(\d{2})$/;
const displayDatePattern = /^(\d{2})\.(\d{2})\.(\d{4})$/;
const isValidDisplayDate = value => {
    const match = String(value || '').match(displayDatePattern);

    if (!match) {
        return false;
    }

    const date = new Date(Date.UTC(match[3], Number(match[2]) - 1, match[1]));

    return date.getUTCFullYear() === Number(match[3])
        && date.getUTCMonth() === Number(match[2]) - 1
        && date.getUTCDate() === Number(match[1]);
};
const formatDateForDisplay = value => {
    const match = String(value || '').match(isoDatePattern);

    return match ? `${match[3]}.${match[2]}.${match[1]}` : value;
};
const normalizeDateForSubmit = value => {
    const match = String(value || '').match(displayDatePattern);

    return match ? `${match[3]}-${match[2]}-${match[1]}` : value;
};

window.initDatepickers = window.initDatepickers || function (root) {
    const container = $(root || document);

    container.find('input[type="date"], input[data-date-picker-enabled="true"]').each(function () {
        const input = $(this);
        const format = input.data('date-format') || displayDateFormat;
        const value = input.val();

        if (input.data('datepicker')) {
            return;
        }

        input
            .attr('type', 'text')
            .attr('autocomplete', 'off')
            .attr('data-date-picker-format', format);

        if (format === displayDateFormat) {
            input.val(formatDateForDisplay(value));

            if (window.initDateInputMask) {
                window.initDateInputMask(input);
            }
        }

        input.datepicker({
            todayHighlight: true,
            autoclose: true,
            language: 'ru',
            format,
            orientation: 'bottom auto',
            container: 'body',
            forceParse: false
        });

        if (format === displayDateFormat && input.val()) {
            input.datepicker('update', input.val());
        }
    });
};

window.initSelectpickers = window.initSelectpickers || function (root) {
    const container = $(root || document);

    container.find('select.selectpicker').selectpicker('refresh');
};

window.initTagInputs = function (root) {
    const container = $(root || document);

    container.find('.js-taggable').each(function () {
        const input = $(this);

        if (input.data('tagit-initialized')) {
            return;
        }

        input.tagit({
            fieldName: 'tags[]',
            caseSensitive: false,
            allowSpaces: false,
            placeholderText: 'Введите теги (метки) через пробел',
            availableTags: input.data('available-tags') || []
        });
        input.data('tagit-initialized', true);
    });
};

window.initRecognitionPeriodControls = function (root) {
    const container = $(root || document);
    const displayFormat = 'DD.MM.YYYY';
    const submitFormat = 'YYYY-MM-DD';
    const parseRecognitionDate = value => {
        const rawValue = String(value || '').trim();

        if (!rawValue) {
            return null;
        }

        const parsed = moment(rawValue, [moment.ISO_8601, 'DD.MM.YYYY', 'D.M.YYYY', 'YYYY-MM-DD', 'YYYY-MM-DD HH:mm:ss', 'YYYY/MM/DD', 'DD/MM/YYYY', 'D/M/YYYY'], true);

        return parsed.isValid() ? parsed.startOf('day') : null;
    };
    const calculateInclusivePeriodEnd = (startDate, months) => {
        const originalDay = startDate.date();
        const endDate = startDate.clone().add(months, 'months');

        return endDate.date() === originalDay ? endDate.subtract(1, 'day') : endDate;
    };
    const buildPresetRanges = startDate => {
        const today = moment().startOf('day');
        const yesterday = today.clone().subtract(1, 'day');

        return {
            'Сегодня': [today.clone(), today.clone()],
            'Вчера': [yesterday.clone(), yesterday.clone()],
            'Текущий месяц': [today.clone().startOf('month'), today.clone().endOf('month').startOf('day')],
            'Прошлый месяц': [today.clone().subtract(1, 'month').startOf('month'), today.clone().subtract(1, 'month').endOf('month').startOf('day')],
            '1 месяц': [startDate.clone(), calculateInclusivePeriodEnd(startDate, 1)],
            '3 месяца': [startDate.clone(), calculateInclusivePeriodEnd(startDate, 3)],
            '6 месяцев': [startDate.clone(), calculateInclusivePeriodEnd(startDate, 6)],
            '1 год': [startDate.clone(), calculateInclusivePeriodEnd(startDate, 12)],
        };
    };
    const updateRecognitionPeriodControl = (control, startDate, endDate) => {
        if (!startDate || !endDate || !control.length) {
            return;
        }

        const normalizedStart = startDate.clone().startOf('day');
        const normalizedEnd = endDate.clone().startOf('day');
        const rangeInput = control.find('.js-recognition-period-range-input');

        control.find('.js-recognition-period-from').val(normalizedStart.format(submitFormat));
        control.find('.js-recognition-period-to').val(normalizedEnd.format(submitFormat));
        control.attr('data-recognition-from', normalizedStart.format(submitFormat));
        control.attr('data-recognition-to', normalizedEnd.format(submitFormat));
        rangeInput.val(`${normalizedStart.format(displayFormat)} - ${normalizedEnd.format(displayFormat)}`);

        const picker = rangeInput.data('daterangepicker');

        if (picker) {
            picker.setStartDate(normalizedStart);
            picker.setEndDate(normalizedEnd);
        }
    };

    window.updateRecognitionPeriodRange = function (formOrControl, recognitionFrom, recognitionTo) {
        const root = $(formOrControl);
        const control = root.hasClass('js-recognition-period-control') ? root : root.find('.js-recognition-period-control').first();
        const startDate = parseRecognitionDate(recognitionFrom);
        const endDate = parseRecognitionDate(recognitionTo) || startDate;

        updateRecognitionPeriodControl(control, startDate, endDate);
    };

    container.find('.js-recognition-period-control').each(function () {
        const control = $(this);
        const rangeInput = control.find('.js-recognition-period-range-input');

        if (rangeInput.data('daterangepicker')) {
            return;
        }

        const initialStart = parseRecognitionDate(control.data('recognition-from')) || moment().startOf('day');
        const initialEnd = parseRecognitionDate(control.data('recognition-to')) || initialStart.clone();

        updateRecognitionPeriodControl(control, initialStart, initialEnd);

        if (!$.fn.daterangepicker) {
            return;
        }

        rangeInput.daterangepicker({
            startDate: initialStart,
            endDate: initialEnd,
            autoUpdateInput: false,
            showDropdowns: true,
            linkedCalendars: false,
            alwaysShowCalendars: true,
            opens: 'right',
            buttonClasses: 'btn btn-sm',
            applyButtonClasses: 'btn-primary',
            cancelButtonClasses: 'btn-white',
            ranges: buildPresetRanges(initialStart),
            locale: {
                format: displayFormat,
                separator: ' - ',
                applyLabel: 'Применить',
                cancelLabel: 'Отмена',
                fromLabel: 'С',
                toLabel: 'По',
                customRangeLabel: 'Произвольный период',
                weekLabel: 'Н',
                daysOfWeek: moment.weekdaysMin(),
                monthNames: moment.months(),
                firstDay: 1
            }
        }, function (startDate, endDate) {
            updateRecognitionPeriodControl(control, startDate, endDate);
        });

        rangeInput.on('show.daterangepicker', function (event, picker) {
            const currentStart = parseRecognitionDate(control.find('.js-recognition-period-from').val()) || picker.startDate.clone().startOf('day') || moment().startOf('day');

            picker.ranges = buildPresetRanges(currentStart);
            picker.updateView();
        });
    });
};

window.initDynamicFormControls = function (root) {
    const container = $(root || document);

    container.find('[data-toggle="tooltip"]').tooltip();
    window.initDatepickers && window.initDatepickers(container);
    window.initSelectpickers && window.initSelectpickers(container);
    window.initRecognitionPeriodControls && window.initRecognitionPeriodControls(container);
    window.initTagInputs && window.initTagInputs(container);
};

$(function () {
    window.initDynamicFormControls(document);

    let deleteUrl = null;
    let contractContextRequestSequence = 0;
    const root = $('.js-income-actions-root').first();
    const successMode = root.data('income-success-mode');
    const tableSelector = root.data('income-table-selector');

    const showModalError = (message) => {
        const alerts = $(`${modalSelector} .js-income-form-alerts`).first();

        alerts.html(`<div class="alert alert-danger">${escapeHtml(message)}</div>`);
    };

    const showPageSuccess = (message) => {
        const alert = $('<div class="alert alert-success alert-dismissible fade show" role="alert"></div>').text(message);
        alert.append('<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>');
        $('.content').first().find('.alert-success').remove();
        $('.content').first().prepend(alert);
    };

    const handleIncomeSuccess = (message) => {
        showPageSuccess(message || 'Операция успешно выполнена');

        if (successMode === 'reload') {
            window.location.reload();
            return;
        }

        if (tableSelector && $(tableSelector).length) {
            $(tableSelector).DataTable().ajax.reload(null, false);
        }
    };

    const clearValidation = form => {
        form.find('.parsley-errors-list.filled').remove();
        form.find('.parsley-error').removeClass('parsley-error');
    };

    const applyValidationErrors = (form, errors) => {
        parseJsonErrors(errors).forEach(({ field, message }) => {
            const input = form.find(`[name="${field}"]`).first();

            if (!input.length && field.indexOf('tags') === 0) {
                form.find('.js-taggable').first().closest('.form-group').append(`<ul class="parsley-errors-list filled width-full" aria-hidden="false"><li class="parsley-required">${escapeHtml(message)}</li></ul>`);
                return;
            }

            if (!input.length) {
                return;
            }

            input.addClass('parsley-error');
            input.closest('.form-group, .js-income-cash-date-row, .js-recognition-period-control').append(`<ul class="parsley-errors-list filled width-full" aria-hidden="false"><li class="parsley-required">${escapeHtml(message)}</li></ul>`);
        });
    };

    const toggleRefundCashDate = form => {
        const affects = form.find('.js-income-affects-cash-flow').is(':checked');
        const row = form.find('.js-income-cash-date-row');
        const input = row.find('[name="cash_date"]');

        row.toggle(affects);
        input.prop('required', affects);
    };

    const refreshSelectpicker = select => {
        if (select.data('selectpicker')) {
            select.selectpicker('refresh');
        }
    };

    const setSelectDisabled = (select, disabled) => {
        select.prop('disabled', disabled);
        refreshSelectpicker(select);
    };

    const setContractDerivedFieldsDisabled = (form, disabled) => {
        setSelectDisabled(form.find('[name="property_id"]'), disabled);
        setSelectDisabled(form.find('[name="client_id"]'), disabled);
        form.find('.js-income-contract-reset').toggle(disabled);
        form.find('.js-income-contract-lock-note').toggleClass('d-none', !disabled);
    };

    const syncIncomeContractLock = form => {
        setContractDerivedFieldsDisabled(form, Boolean(form.find('[name="contract_id"]').val()));
    };

    const initIncomePaymentHistoryTables = root => {
        const container = $(root || document);
            const language = window.dataTablesRussianLanguage || {
            processing: 'Подождите...',
            search: 'Поиск:',
            lengthMenu: 'Показать _MENU_ записей',
            info: 'Записи с _START_ до _END_ из _TOTAL_ записей',
            infoEmpty: 'Записи с 0 до 0 из 0 записей',
            infoFiltered: '(отфильтровано из _MAX_ записей)',
            loadingRecords: 'Загрузка записей...',
            zeroRecords: 'Записи отсутствуют.',
            emptyTable: 'В таблице отсутствуют данные',
            paginate: {
                first: 'Первая',
                previous: 'Предыдущая',
                next: 'Следующая',
                last: 'Последняя'
            }
        };

        container.find('.js-income-payment-history-table').each(function () {
            const table = $(this);

            if (!$.fn.DataTable || $.fn.DataTable.isDataTable(table)) {
                return;
            }

            const order = [];
            const numberColumns = [];

            table.find('thead th').each((index, th) => {
                if ($(th).data('order')) {
                    order.push([index, $(th).data('order')]);
                }

                if ($(th).data('number')) {
                    numberColumns.push(index);
                }
            });

            if (!table.find('tfoot').length) {
                table.append($('<tfoot/>').append(table.find('thead tr').clone()));
            }

            const options = {
                order,
                pageLength: 10,
                lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
                responsive: window.dataTableResponsiveDetailsOptions ? window.dataTableResponsiveDetailsOptions() : true,
                language,
                fixedHeader: false,
                columnDefs: [
                    { render: $.fn.dataTable.render.number(' ', '.', 2), targets: numberColumns }
                ]
            };

            if (table.data('url')) {
                options.processing = true;
                options.serverSide = true;
                options.ajax = { url: table.data('url') };
                options.columns = [
                    window.dataTableDetailsControlColumn(),
                    {
                        data: 'cash_date',
                        name: 'cash_date',
                        className: 'text-nowrap table-col-fixed',
                        responsivePriority: 1,
                        render: function (data, type, row) {
                            return type === 'sort' ? row.cash_date_sort : data;
                        }
                    },
                    {
                        data: 'recognition_period',
                        name: 'recognition_period',
                        responsivePriority: 60,
                        createdCell: function (td) { td.style.whiteSpace = 'normal'; },
                        render: function (data, type, row) {
                            if (type === 'display') {
                                return (data || '').replace(/\s+-\s+/, '<br>');
                            }

                            return type === 'sort' ? row.recognition_sort : data;
                        }
                    },
                    {
                        data: 'amount',
                        name: 'amount',
                        className: 'text-nowrap text-right table-col-fixed',
                        responsivePriority: 2,
                        render: function (data, type, row) {
                            return type === 'display' ? row.amount_display : data;
                        }
                    },
                    { data: 'income_group', name: 'income_group', responsivePriority: 50, createdCell: function (td) { td.style.whiteSpace = 'normal'; } },
                    { data: 'description', name: 'description', className: 'table-col-grow', responsivePriority: 20 },
                    { data: 'actions', name: 'actions', orderable: false, searchable: false, className: 'text-nowrap text-center table-col-actions all', responsivePriority: 1 }
                ];
            }

            const api = table.DataTable(options);

            if (window.enhanceResponsiveDataTableDetails) {
                window.enhanceResponsiveDataTableDetails(table, api);
            }
            setTimeout(() => {
                api.columns.adjust();

                if (api.responsive && typeof api.responsive.recalc === 'function') {
                    api.responsive.recalc();
                }
            }, 0);
        });
    };

    const adjustIncomePaymentHistoryTables = root => {
        const container = $(root || document);

        container.find('.js-income-payment-history-table').each(function () {
            const table = $(this);

            if ($.fn.DataTable && $.fn.DataTable.isDataTable(table)) {
                const api = table.DataTable();
                api.columns.adjust();

                if (api.responsive && typeof api.responsive.recalc === 'function') {
                    api.responsive.recalc();
                }
            }
        });
    };

    const clearIncomeContractContext = form => {
        form.find('#income-contract-context-container').empty();
        form.closest('.js-income-form').siblings('#rental-payment-history-container').empty();
        $('#rental-payment-history-container').empty();
    };

    const applyIncomeContractContext = (form, data) => {
        if (data.contract) {
            form.find('[name="property_id"]').val(data.contract.property_id);
            form.find('[name="client_id"]').val(data.contract.client_id);
        }

        form.find('#income-contract-context-container').html(data.suggestion_html || '');
        $('#rental-payment-history-container').html(data.history_html || '');
        syncIncomeContractLock(form);
        window.initDynamicFormControls && window.initDynamicFormControls(form);
        initIncomePaymentHistoryTables(document);
    };

    const parseRentalDefaults = button => {
        const raw = button.attr('data-rental-defaults') || '{}';

        if (typeof button.data('rental-defaults') === 'object') {
            return button.data('rental-defaults');
        }

        try {
            return JSON.parse(raw);
        } catch (error) {
            return {};
        }
    };

    const applyRentalDefaultsToForm = (form, defaults) => {
        if (!defaults) {
            return;
        }

        if (Object.prototype.hasOwnProperty.call(defaults, 'income_group')) {
            form.find('[name="income_group"]').val(defaults.income_group);
            refreshSelectpicker(form.find('[name="income_group"]'));
        }

        if (Object.prototype.hasOwnProperty.call(defaults, 'amount')) {
            form.find('[name="amount"]').val(defaults.amount);
        }

        if (Object.prototype.hasOwnProperty.call(defaults, 'description')) {
            form.find('[name="description"]').val(defaults.description);
        }

        if (Object.prototype.hasOwnProperty.call(defaults, 'cash_date')) {
            const input = form.find('[name="cash_date"]');
            const displayValue = formatDateForDisplay(defaults.cash_date);

            input.val(displayValue);

            if (input.data('datepicker') && isValidDisplayDate(displayValue)) {
                input.datepicker('update', displayValue);
            }
        }

        if (Object.prototype.hasOwnProperty.call(defaults, 'recognition_from') || Object.prototype.hasOwnProperty.call(defaults, 'recognition_to')) {
            window.updateRecognitionPeriodRange(form, defaults.recognition_from, defaults.recognition_to);
        }
    };

    const prepareIncomeFormForSubmit = form => {
        form.find('[name="property_id"], [name="client_id"]').prop('disabled', false);
        refreshSelectpicker(form.find('[name="property_id"]'));
        refreshSelectpicker(form.find('[name="client_id"]'));
    };

    const initModalContent = modal => {
        window.initDynamicFormControls(modal);
        modal.find('.js-income-form').each(function () {
            syncIncomeContractLock($(this));
        });
        initIncomePaymentHistoryTables(modal);
        const refundForm = modal.find('.js-income-refund-form');
        if (refundForm.length) {
            toggleRefundCashDate(refundForm);
        }
    };

    $('.js-income-refund-form').each(function () {
        toggleRefundCashDate($(this));
    });
    $('.js-income-form').each(function () {
        syncIncomeContractLock($(this));
    });
    initIncomePaymentHistoryTables(document);

    $(document).on('click', '.js-income-open-modal', async function (event) {
        event.preventDefault();
        const button = $(this);
        const url = button.data('income-modal-url') || button.attr('href');
        const modal = $(modalSelector);

        try {
            const response = await Axios.get(url);
            modal.find('.js-income-modal-title').text(response.data.title || button.data('income-modal-title') || 'Операция с доходом');
            modal.find('.js-income-modal-body').html(response.data.html || '');
            modal.modal('show');
            initModalContent(modal);
        } catch (error) {
            alert('Не удалось загрузить форму. Обновите страницу и попробуйте снова.');
        }
    });

    $(modalSelector).on('shown.bs.modal', function () {
        adjustIncomePaymentHistoryTables(this);
    });

    $(document).on('change', '.js-income-form [name="contract_id"]', async function () {
        const select = $(this);
        const form = select.closest('.js-income-form');
        const contractId = select.val();

        if (!contractId) {
            contractContextRequestSequence++;
            setContractDerivedFieldsDisabled(form, false);
            clearIncomeContractContext(form);
            return;
        }

        try {
            const urlTemplate = form.data('income-contract-defaults-url-template');
            const requestSequence = ++contractContextRequestSequence;
            const response = await Axios.get(String(urlTemplate).replace('__ID__', contractId));

            if (requestSequence !== contractContextRequestSequence || String(select.val()) !== String(contractId)) {
                return;
            }

            applyIncomeContractContext(form, response.data);
        } catch (error) {
            showModalError('Не удалось подставить данные по договору.');
        }
    });

    $(document).on('click', '.js-income-contract-reset', function () {
        const form = $(this).closest('.js-income-form');
        const contract = form.find('[name="contract_id"]');

        contract.val('');
        refreshSelectpicker(contract);
        contractContextRequestSequence++;
        setContractDerivedFieldsDisabled(form, false);
        clearIncomeContractContext(form);
    });

    $(document).on('click', '.js-income-apply-rental-defaults', function () {
        const button = $(this);
        applyRentalDefaultsToForm(button.closest('.js-income-form'), parseRentalDefaults(button));
    });

    $(document).on('change', '.js-income-refund-form .js-income-affects-cash-flow', function () {
        toggleRefundCashDate($(this).closest('.js-income-refund-form'));
    });

    $(document).on('submit', '.js-income-form, .js-income-refund-form', async function (event) {
        const form = $(this);

        if (form.hasClass('js-income-form')) {
            prepareIncomeFormForSubmit(form);
        }

        if (String(form.data('income-is-modal')) !== '1') {
            return;
        }

        event.preventDefault();
        const submitButton = form.find('.js-income-submit').first();
        const originalText = submitButton.text();

        clearValidation(form);
        submitButton.prop('disabled', true).text('Сохраняем...');

        form.find(`input[data-date-picker-format="${displayDateFormat}"]`).each((i, el) => {
            const input = $(el);

            input.val(normalizeDateForSubmit(input.val()));
        });

        try {
            const response = await Axios({
                method: 'post',
                url: form.attr('action'),
                data: new FormData(form[0])
            });

            $(modalSelector).modal('hide');
            handleIncomeSuccess(response.data.message);
        } catch (error) {
            if (error.response && error.response.status === 422) {
                applyValidationErrors(form, error.response.data.errors || {});
                showModalError(error.response.data.message || 'Проверьте корректность заполнения формы.');
            } else {
                showModalError('Не удалось выполнить операцию. Попробуйте еще раз.');
            }
        } finally {
            form.find(`input[data-date-picker-format="${displayDateFormat}"]`).each((i, el) => {
                const input = $(el);
                const displayValue = formatDateForDisplay(input.val());

                input.val(displayValue);

                if (input.data('datepicker') && isValidDisplayDate(displayValue)) {
                    input.datepicker('update', displayValue);
                }
            });
            submitButton.prop('disabled', false).text(originalText);
            if (form.hasClass('js-income-form')) {
                syncIncomeContractLock(form);
            }
        }
    });

    $(document).on('click', '.js-income-delete', function (event) {
        event.preventDefault();
        deleteUrl = $(this).data('income-delete-url');
        $(`${deleteModalSelector} .js-income-delete-alerts`).empty();
        $(deleteModalSelector).modal('show');
    });

    $(document).on('click', '.js-income-confirm-delete', async function () {
        if (!deleteUrl) {
            return;
        }

        try {
            const response = await Axios.delete(deleteUrl);
            $(deleteModalSelector).modal('hide');
            handleIncomeSuccess(response.data.message);
        } catch (error) {
            const message = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : 'Не удалось удалить доход.';
            $(`${deleteModalSelector} .js-income-delete-alerts`).html(`<div class="alert alert-danger">${escapeHtml(message)}</div>`);
        }
    });
});
